module.exports = __webpack_public_path__ + "img/magento-security-services@2x.d777b7a1.webp";